<template>
  <div>
    <MTop title="收藏夹" />
    <div style="padding:20px 20px 10px 20px;">
      <el-input prefix-icon="el-icon-search" v-model="value" placeholder="搜索"></el-input>
    </div>
    <div style="padding:0px 10px;background:#fff;" class="">
      <Collect @cancelCollect="cancelFavorite" :isShowCan="isShow" :videoList="collectVideoList" :textword="word" />
    </div>
  </div>
</template>

<script>
import "boqii-modal";
// let propsdata = []
// this.$modal({
//   template:'',
//   params:propsdata,//要传入模态框的参数
//   enter:'slideInUp',//模态框要进入时的动画，不需要动画时填none
//   leave:'slideOutDown',
//   success:function(data){
//     console.log('success',data)
//   },
//   fail:function(err){
//     console.log('error',err)
//   },
//   duration: 700,//默认是700，动画执行时的过度时间
//   backScroll: false,//默认为false,模态框展开时是否让背面滚动，true为滚动
//   backdropClickable: true,//默认为false,灰色背景是可以点击
//   backdropColor: 'transparent',// 蒙版背景颜色，不填默认是rgba(0,0,0,0.7)

// })
import Collect from "../../common/moblist.vue";
import AComponent from "../popcomponent/AComponent";
import { mapState } from 'vuex';
export default {
  components: {
    Collect
  },
  data: function() {
    return {
      collectVideoList: [],
      word: "暂无收藏",
      value: "",
      isShow: true
    };
  },
  methods: {
    VideoCollectList: async function() {
      var res = await this.$http.get("/v1/collect/videoCollectList?page=1");
      var { code, data, message } = res.data;

      if (code == 0) {
        this.collectVideoList = data;
        console.log(this.collectVideoList);
      } else if (code == 40100) {
        this.$router.push("/login");
      } else {
        this.$message.error(message);
      }
    },
    // 取消收藏
    cancelFavorite(picid) {
      this.$layer
        .dialog({
          title: ["", "background:#fff;"],
          content: "是否取消收藏?",
          contentClass: "className",
          btn: ["取消", "确定"]
          // time: 1000,
        })
        .then(async res => {
          console.log(res);
          // res为0点击了左边，1点击了右边
          let positon = res == 0 ? false : true;
          if (positon) {
            var clres = await this.$http.post(
              `/v1/collect/collectionVideoInfo?id=${picid}`
            );
            var { code, message, data } = clres.data;
            if (code == 0) {
              // this.$message.success("取消成功");
              this.$layer.toast({
                icon: "icon-check", // 图标clssName 如果为空 toast位置位于下方,否则居中
                content: "取消收藏成功",
                time: 1000 // 自动消失时间 toast类型默认消失时间为2000毫秒
              });

              this.VideoCollectList();
            }
          }
        });
      // ------
      // this.$confirm("是否取消收藏？", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning"
      // })
      //   .then(async () => {
      //     console.log(picid);
      //     var clres = await this.$http.post(
      //       `/v1/collect/collectionVideoInfo?id=${picid}`
      //     );
      //     var { code, message, data } = clres.data;
      //     if (code == 0) {
      //       this.$message.success("取消成功");
      //       this.VideoCollectList();
      //     }
      //   })
      //   .catch(() => {
      //   });
    }
  },
  mounted: function() {
    this.VideoCollectList();
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/mobile/personinfo/collect.vue